<template>
	<div class="list d-flex h-100 flex-column align-items-center px-3">
		<div class="d-flex flex-column align-items-center pt-5 p-3 text-center" v-if="!getSlimFilters || getIsLoadingEvents">
            <span class="bold">Loading Filters</span>
            <loader size="small"></loader>
        </div>

		<div v-else class="d-flex flex-column w-100 h-100 pt-4">
			<!-- Products filter -->
			<div class="w-100 flex-grow-1 overflow-auto">
				<!-- Calendar filters -->
				<calendar-filters class="mb-3" @change="filtersChanged"/>

				<!-- Product Filter -->
				<product-filter
					:products="getProductsShowingOnCalendar"
					@change="updateFilters()"
					@loaded="updateFilters()"
				/>
			</div>

			<div class="border-top-light mt-2">
				<div class="w-100 mt-2">
					<multiselect
						v-model="selectedLocations"
						:options="locations"
						:multiple="true"
						:close-on-select="false"
						:clear-on-select="false"
						:preserve-search="false"
						track-by="id"
						label="name"
						selectLabel=""
						deselectLabel=""
						selectedLabel=""
						class=""
						placeholder="All Locations"
						open-direction="top"
						@input="updateFilters"
					>

						<template slot="selection" slot-scope="{ values, search, isOpen }">
							<span class="multiselect__single"  v-if="values.length > 1" v-tooltip.auto="values.length + ' products selected'">{{ values.length }} locations selected</span>
							<span class="multiselect__single" v-else-if="values.length == 1 " v-tooltip.auto="values[0].name">{{values[0].name}} </span>
						</template>

						<template slot="option" slot-scope="props">
							<i v-if="selectedLocations.filter(i => {return i.name == props.option.name}).length" class="far fa-check-square"></i>
							<i v-else class="far fa-square"></i>
							<span v-tooltip.auto="props.option.name">{{props.option.name}}</span>
						</template>
					</multiselect>
				</div>

				<div class="w-100 mt-2">
					<multiselect
						v-model="selectedResources"
						:options="resources"
						:multiple="true"
						:taggable="false"
						:close-on-select="false"
						:clear-on-select="false"
						:preserve-search="false"
						track-by="id"
						label="name"
						selectLabel=""
						deselectLabel=""
						selectedLabel=""
						class=""
						placeholder="All Resources"
						open-direction="top"
						@input="updateFilters"
					>

						<template slot="selection" slot-scope="{ values, search, isOpen }">
							<span class="multiselect__single"  v-if="values.length > 1" v-tooltip.auto="values.length + ' products selected'">{{ values.length }} resources selected</span>
							<span class="multiselect__single" v-else-if="values.length == 1 " v-tooltip.auto="values[0].name">{{values[0].name}}</span>
						</template>

						<template slot="option" slot-scope="props">
							<i v-if="selectedResources.filter(i => {return i.id == props.option.id}).length" class="far fa-check-square"></i>
							<i v-else class="far fa-square"></i>
							<span v-tooltip.auto="props.option.name">{{props.option.name}}</span>
						</template>
					</multiselect>
				</div>

				<div class="w-100 d-flex mt-2">
					<button
						class="btn tertiary wide reset"
						@click="renderFilters(getStoredEvents, true)"
					>
						Clear All
					</button>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import { mapGetters, mapActions } from "vuex";

	import extendedVSelect from "@/extends/vue-select";
	import Loader from "@/tools/loaders/loader1";
	import Multiselect from "vue-multiselect";
	import ProductFilter from "./filters/productFilter";
	import calendarFilters from "./filters/calendarFilters";

	export default {
		props: {
			defaultView: String,
			calendarApi: {
				type: Object,
				default: null,
			},
		},
		data() {
			return {
				currentView: this.defaultView,
				isVisible: false,
				selectedProduct: [],
				selectedTransport: null,
				selectedResources: [],
				selectedLocations: [],
				selectedCategory: null,
				checkboxes: {
					transport: "Hide transport",
					product: "Hide product name",
					availability: "Hide availability",
				}
			};
		},
		created() {
			this.downloadFilterLocations();
		},
		watch: {
			getStoredEvents(newVal, oldVal) {
				this.updateFilters();
			},
			getEventColors(newVal, oldVal) {
				if (newVal && newVal.length && (!oldVal || !oldVal.length)) {
					this.updateFilters();
				}
			},
		},
		computed: {
			...mapGetters([
				"getExpandedDay",
				"getCurrentView",
				"getFilters",
				"getStoredEvents",
				"getSlimFilters",
				"getIsLoadingEvents",
				"getfilterBlacklistProducts",
				"getProductsShowingOnCalendar",
				"getCurrentAccountType",
				"getLocations",
				"getEventColors",
			]),
			products() {
				if (this.getStoredEvents !== undefined) {
					let products = [];

					this.getStoredEvents.forEach((event) => {
						if (products.filter((product) => product.id == event.id).length == 0) {
							if (event.eventType == "sunrise") {
								products.push({
									name: "Sunrise",
									id: event.id,
									color: 0,
									code: "sunrise"
								});
							}
							if (event.eventType == "sunset") {
								products.push({
									name: "Sunset",
									id: event.id,
									color: 0,
									code: "sunrise"
								});
							}
						}

						//check if product is already present on products
						let filteredArr = products.filter((product) => {
							return product.id == event.product.id;
						});

						if (filteredArr.length == 0 && event.product.name) {
							products.push({
								name: event.product.name,
								id: event.product.id,
								color: event.product.color,
								code: event.product.code
							});
						}
					});
					return products;
				}
			},
			resources() {
				return this.getSlimFilters.resourceList;
			},
			locations() {
				return this.getLocations.map((name, index) => ({
					id: index + 1,
					name
				}))
			},
			categories() {
				return ["All categories"].concat(this.getSlimFilters.categoryList);
			},
			filters() {
				return this.getFilters;
			},
		},
		methods: {
			...mapActions([
				"updateSidebar",
				"updateCurrentView",
				"toggleCalendarFilter",
				"changefilterBlacklistProducts",
				"updateSupplierSettings",
				"downloadFilterLocations"
			]),
			filtersChanged() {
				this.$emit('changeFilters');
			},
			reloadEvents(view, date) {
				let d = moment(date);

				this.$emit("reloadEvents", {
					start: this.formatDate(d.clone().startOf("month")),
					end: this.formatDate(d.clone().endOf("month")),
				});
			},
			showFilters(e) {
				this.isVisible = true;
			},
			hideFilters(e) {
				this.isVisible = false;
			},
			updateFilters(e) {
				let filtered = this.getStoredEvents;

				// Filter by Product
				if (this.getfilterBlacklistProducts && this.getfilterBlacklistProducts != null && this.getfilterBlacklistProducts.length != 0) {
					filtered = filtered.filter((event) => {
						if (event.hasOwnProperty('code') && (event.eventType === 'sunrise' || event.eventType === 'sunset')) {
                            return true;
                        }

						return (
							this.getfilterBlacklistProducts.find(
								(blackListProduct) => blackListProduct.id == event.product.id
							) == undefined
						);
					});
				} else if (this.getfilterBlacklistProducts.length == 0) {
					filtered = this.getStoredEvents;
				}

				// Filter by Resource
				if (this.selectedResources && this.selectedResources != null && this.selectedResources.length != 0) {
					filtered = filtered.filter((event) => {
						let isFound = false;

                        if (event.hasOwnProperty('code') && (event.eventType === 'sunrise' || event.eventType === 'sunset')) {
                            return true;
                        }

						for (let selectedResourceItem of this.selectedResources) {
							for (let selectedEventResource of event.eventResources) {
								if (selectedResourceItem.id == selectedEventResource.id) {
									isFound = true;
								}
							}
						}

						return isFound;
					});
				}

				// Filter by Locations
				if (this.selectedLocations && this.selectedLocations != null && this.selectedLocations.length != 0) {
					filtered = filtered.filter((event) => {
						let isFound = false;

                        if (event.hasOwnProperty('code') && (event.eventType === 'sunrise' || event.eventType === 'sunset')) {
                            return true;
                        }

						for (let selectedLocationItem of this.selectedLocations) {
							if (selectedLocationItem.name == event.location) {
								isFound = true;
							}
						}

						return isFound;
					});
				}

				if (this.selectedCategory) {
					if (this.selectedCategory == "All categories") {
						this.selectedCategory = null;

						return false;
					}

					filtered = filtered.filter(
						(i) => i.product.category.id === this.selectedCategory.id
					);
				}

				this.renderFilters(filtered, false);
			},

			// Remove and re-fetch source for events.
			renderFilters(source, reset) {
				if (!this.calendarApi) return;

				this.calendarApi.removeAllEvents();
				this.calendarApi.addEventSource(source);

				// If 'reset' is set to true, all filters are cleared
				if (reset) {
					this.selectedTransport = null;
					this.selectedResources = [];
					this.selectedLocations = [];
					this.selectedCategory = null;

					// Clear "Calendar Filters"
					this.getCurrentAccountType.isToHideCalendarEventCanceled = false;
					this.getCurrentAccountType.isToHideCalendarEventEmpty = false;
					this.getCurrentAccountType.showHidenProductsOnCalendar = false;

					// Update Calendar with "Filters"
					this.updateSupplierSettings(this.getCurrentAccountType).then((res) => {
						this.filtersChanged();
					})

					this.changefilterBlacklistProducts([]);
				}
			}
		},
		components: {
			vSelect: extendedVSelect,
			Loader,
			Multiselect,
			ProductFilter,
			calendarFilters,
		},
	};
</script>

<style lang="scss" scoped>
	@import "../../assets/scss/_variables.scss";

	.filters {
		height: 7vh;
		border-bottom: 1px solid $light;

		.v-select.searchable {
			input[type="search"] {
				font-size: $font-size-small;
				line-height: 1.4rem;
				height: 1.4rem;
				padding: 0 2rem 0 0.75rem;
			}

			.dropdown-toggle {
				height: 34px;
			}

			.open-indicator {
				bottom: 0;
			}
		}

		.type-filters {
			.dropdown {
				margin-right: 1rem;
			}
		}
	}
</style>


// WEBPACK FOOTER //
// Filters.vue?64d82fdc